module.exports = __webpack_public_path__ + "img/61ffa.ed6f11cb.svg";